import ClientAdminModule from './client-admin';
import NotificationsModule from './notifications';
import NotificationsAdminModule from './notifications-admin';
import ProjectModule from './project';
import ProjectAdminModule from './project-admin';
import PublicModule from './public';
import QAQCModule from './QAQC';
import UserAdminModule from './user-admin';
import UserFeedbackAdminModule from './user-feedback-admin';

export {
  ClientAdminModule,
  NotificationsAdminModule,
  NotificationsModule,
  ProjectAdminModule,
  ProjectModule,
  QAQCModule,
  UserAdminModule,
  UserFeedbackAdminModule,
};

const pages = [
  ...ProjectModule.pages,
  ...ClientAdminModule.pages,
  ...ProjectAdminModule.pages,
  ...UserAdminModule.pages,
  ...NotificationsAdminModule.pages,
  ...NotificationsModule.pages,
  ...QAQCModule.pages,
  ...UserFeedbackAdminModule.pages,
];

export const publicPages = [
  ...PublicModule.pages,
];

export default pages;
